import { Flex, Icon } from "@chakra-ui/react";
import { SiAnthropic, SiSlack } from "react-icons/si";

export function SlackLogo() {
  return (
    <Flex align="center" justify="center" w="8" h="8" borderRadius="lg" bg="#4A154B" flexShrink={0}>
      <Icon as={SiSlack} color="white" boxSize="4" />
    </Flex>
  );
}

export function ClaudeLogo() {
  return (
    <Flex align="center" justify="center" w="8" h="8" borderRadius="lg" bg="#CC785C" flexShrink={0}>
      <Icon as={SiAnthropic} color="white" boxSize="4" />
    </Flex>
  );
}
